import { render, staticRenderFns } from "./ProjetosDistrito.vue?vue&type=template&id=4eb666a4"
import script from "./ProjetosDistrito.vue?vue&type=script&lang=ts"
export * from "./ProjetosDistrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports